if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if(this.form) {
          this.form.querySelector('[name="id"]').disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              // Dispatch a custom event when a product is added to the cart
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: { source: 'product-form', response: response }
              }));
              
              // Directly initialize the warranty toggle after a short delay
              setTimeout(() => {
                const warrantyToggle = document.getElementById('warranty-toggle');
                if (warrantyToggle) {
                  console.log("Directly initializing warranty toggle from product-form.js");
                  
                  // Get the related elements
                  const warrantyStatus = document.getElementById('warranty-status');
                  const totalElement = document.querySelector('.totals__total-value');
                  const checkoutPriceElement = document.querySelector('#CartDrawer-Checkout .flex.items-center.gap-15 span:last-child');
                  
                  if (warrantyStatus && totalElement && checkoutPriceElement) {
                    // Extract price from settings
                    const priceText = warrantyToggle.getAttribute('data-price') || '+£5.99';
                    const warrantyPrice = parseFloat(priceText.replace(/[^0-9.-]+/g, '')) || 5.99;
                    
                    // Get status text
                    const defaultStatusText = warrantyStatus.textContent;
                    const activeStatusText = 'Protection added';
                    const activeColor = '#0066cc';
                    
                    // Store original values
                    const originalTotalText = totalElement.textContent;
                    const originalCheckoutText = checkoutPriceElement.textContent;
                    
                    // Create visual elements
                    let visualTotalElement = document.querySelector('.warranty-visual-total');
                    if (!visualTotalElement) {
                      visualTotalElement = document.createElement('p');
                      visualTotalElement.className = 'totals__total-value warranty-visual-total';
                      visualTotalElement.style.display = 'none';
                      totalElement.parentNode.insertBefore(visualTotalElement, totalElement.nextSibling);
                    }
                    
                    let visualCheckoutElement = document.querySelector('.warranty-visual-checkout');
                    if (!visualCheckoutElement) {
                      visualCheckoutElement = document.createElement('span');
                      visualCheckoutElement.className = 'warranty-visual-checkout';
                      visualCheckoutElement.style.display = 'none';
                      checkoutPriceElement.parentNode.insertBefore(visualCheckoutElement, checkoutPriceElement.nextSibling);
                    }
                    
                    // Extract original numeric values
                    const originalTotalValue = parseFloat(originalTotalText.replace(/[^0-9.-]+/g, ''));
                    const originalCheckoutValue = parseFloat(originalCheckoutText.replace(/[^0-9.-]+/g, ''));
                    
                    // Calculate totals with warranty
                    const totalWithWarranty = originalTotalValue + warrantyPrice;
                    const checkoutWithWarranty = originalCheckoutValue + warrantyPrice;
                    
                    // Format the totals with warranty
                    const currencyFormat = originalTotalText.replace(/[\d,.]+/g, '').trim();
                    const checkoutCurrencyFormat = originalCheckoutText.replace(/[\d,.]+/g, '').trim();
                    const formattedTotalWithWarranty = currencyFormat + totalWithWarranty.toFixed(2);
                    const formattedCheckoutWithWarranty = checkoutCurrencyFormat + checkoutWithWarranty.toFixed(2);
                    
                    // Set the visual elements text
                    visualTotalElement.textContent = formattedTotalWithWarranty;
                    visualCheckoutElement.textContent = formattedCheckoutWithWarranty;
                    
                    // Copy styling from original elements
                    visualTotalElement.style.fontWeight = window.getComputedStyle(totalElement).fontWeight;
                    visualTotalElement.style.color = window.getComputedStyle(totalElement).color;
                    visualCheckoutElement.style.fontWeight = window.getComputedStyle(checkoutPriceElement).fontWeight;
                    visualCheckoutElement.style.color = window.getComputedStyle(checkoutPriceElement).color;
                    
                    // Remove any existing event listeners
                    warrantyToggle.removeEventListener('change', window.warrantyToggleHandler);
                    
                    // Define the event handler function
                    window.warrantyToggleHandler = function() {
                      if (this.checked) {
                        // Show the visual totals with warranty
                        totalElement.style.display = 'none';
                        visualTotalElement.style.display = 'block';
                        checkoutPriceElement.style.display = 'none';
                        visualCheckoutElement.style.display = 'inline-block';
                        
                        // Update the status text
                        warrantyStatus.textContent = activeStatusText;
                        warrantyStatus.classList.add('active');
                        warrantyStatus.style.color = activeColor;
                        warrantyStatus.style.fontWeight = 'bold';
                      } else {
                        // Show the original totals
                        totalElement.style.display = 'block';
                        visualTotalElement.style.display = 'none';
                        checkoutPriceElement.style.display = 'inline-block';
                        visualCheckoutElement.style.display = 'none';
                        
                        // Reset the status text
                        warrantyStatus.textContent = defaultStatusText;
                        warrantyStatus.classList.remove('active');
                        warrantyStatus.style.color = '';
                        warrantyStatus.style.fontWeight = 'normal';
                      }
                    };
                    
                    // Add the event listener
                    warrantyToggle.addEventListener('change', window.warrantyToggleHandler);
                  }
                }
              }, 1000); // Longer delay to ensure everything is rendered
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
